// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"1ae7da26","977":"31f903f1"}[chunkId] + ".chunk.js";
};